import { exists } from '@/helpers/utilities';

export let mixin = ({ node = null, config = {} } = {}) => {
    if (!node) return false;

    let state = {
        node,
        offset: null,
        justScrolled: false,
    };

    let module = {
        setStickyNav() {
            state.node.style.position = 'fixed';
            state.node.style.top = 0;
        },
        toggleStickyNav() {
            let isNearTop = window.scrollY < 30;
            let method = isNearTop ? 'remove' : 'add';
            state.node.classList[method]('js-is-sticky');

            if (isNearTop) {
                window.dispatchEvent(new CustomEvent('stickyNavReset'));
            }
        },
        onWindowScroll() {
            this.toggleStickyNav();
        },
        setEventBindings() {
            window.addEventListener('scroll', this.onWindowScroll.bind(this));
        },
        init() {
            if (!exists(state.node)) return;
            this.setEventBindings();
            this.setStickyNav();
            this.toggleStickyNav();
        },
    };

    return module.init();
};

export default {
    init({ selector, context, config = {} } = {}) {
        return [...document.querySelectorAll(selector)].map((node) => {
            return mixin({ node, config });
        });
    },
};
